
import Vue from 'vue'

export default Vue.extend({
  name: 'SwiperExample',
  data() {
    return {
      slides: [
        { content: 'Slide 1' },
        { content: 'Slide 2' },
        { content: 'Slide 3' },
        { content: 'Slide 4' },
        { content: 'Slide 5' }
      ]
    }
  }
})
